export default "__VITE_ASSET__mEuCUyIJ__"